const AutoSmsClientSetting = () => {
	return <></>
}

export default AutoSmsClientSetting
